import React, { Component } from "react";
import {
  Row, Button, UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle, Collapse
} from "reactstrap";
import { injectIntl } from "react-intl";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";

class ListPageHeading extends Component {
  constructor(props) {
    super();
    this.state = {
      displayOptionsIsOpen: false,
    };
  }

  toggleDisplayOptions = () => {
    this.setState(prevState => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen
    }));
  };

  render() {
    const { messages } = this.props.intl;
    const { heading, orderColumn, orderColumns, changeOrderBy, searchKeyword, onChange } = this.props;
    const { displayOptionsIsOpen } = this.state;

    return (
      <Row>
        <Colxx xxs="12">
          <div className="mb-2">
            <h1>
              <IntlMessages id={heading} />
            </h1>

            <div className="text-zero top-right-button-container" />
          </div>

          <div className="mb-2">
            <Button color="empty" className="d-inline-block d-md-none" onClick={this.toggleDisplayOptions}>
              <IntlMessages id="pages.display-options" /> <i className="simple-icon-arrow-down align-middle" />
            </Button>

            <Collapse isOpen={displayOptionsIsOpen} className="d-md-block" id="displayOptions">
              <div className="d-block d-md-inline-block">
                <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                  <DropdownToggle caret color="outline-dark" size="xs">
                    <IntlMessages id="request.orderby" />
                    {orderColumn && <IntlMessages id={`request.${orderColumn.label}`} />}
                  </DropdownToggle>

                  <DropdownMenu>
                    {orderColumns
                      && Object.values(orderColumns).length
                      && orderColumns.map((o, index) => (
                        <DropdownItem key={o.label} onClick={() => changeOrderBy(o.column, o.direction)}>
                          <IntlMessages id={`request.${o.label}`} />
                        </DropdownItem>
                      ))
                    }
                  </DropdownMenu>
                </UncontrolledDropdown>

                <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                  <input
                    type="text"
                    name="keyword"
                    id="search"
                    placeholder={messages["menu.search"]}
                    defaultValue={searchKeyword}
                    onChange={onChange}
                  />
                </div>
              </div>
            </Collapse>
          </div>
          <Separator className="mt-3" />
        </Colxx>
      </Row>
    );
  }
}

export default injectIntl(ListPageHeading);
